import React, {useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import clsx from "clsx";
import css from './BlogArticle.module.css';
import parse from 'html-react-parser';
import BlogArticleApi from "./BlogArticle.api";
import Typography from "@mui/material/Typography";

export const BlogArticle = () => {

    const [article, setArticle] = useState(null);
    const [isArticle, setIsArticle] = useState(false);
    const [categories, setCategories] = useState([]);
    const [isCategories, setIsCategories] = useState('');


    useEffect(() => {
        const fetchArticles = async () => {
            const blogArticleApi = new BlogArticleApi();
            try {
                const article = await blogArticleApi.article();
                console.log(article);
                if (article?.link !== undefined
                    && article?.title !== undefined
                    && article?.content !== undefined
                ) {
                    setArticle(article);
                }
            } catch (error) {
                console.error("Błąd podczas pobierania artykułów:", error);
            }
        };

        if (!isArticle) {
            setIsArticle(true);
            fetchArticles();
        }

    }, []);

    useEffect(() => {
        const fetchCateg = async () => {
            const blogArticleApi = new BlogArticleApi();
            try {
                const data = await blogArticleApi.categories();
                console.log(data);
                setCategories(data);
            } catch (error) {
                console.error("Błąd podczas pobierania kategorii:", error);
            }
        };

        if (!isCategories) {
            setIsCategories(true);
            fetchCateg();
        }

    }, []);

    return (
        article && (
            <Box className={clsx(css.blogArticle, 'apla')}>

                <Box className={clsx(css.article)}>

                    <Typography className={clsx(css.title)} variant="h4">
                        {article.title}
                    </Typography>

                    <Box className={clsx(css.main)}>
                        <Box className={clsx(css.rightColumn)}>
                            <img src={article.mainImgUrl} sx={{}}/>

                            <Box className={clsx(css.excerpt)}>
                                {parse(article.excerpt)}
                            </Box>
                        </Box>

                        <Box className={clsx(css.content)}>
                            {parse(article.content)}
                        </Box>
                    </Box>

                    <Box className={clsx(css.footer)}>
                        <Box className={clsx(css.url)}>
                            <a href={article.link} target="_blank" rel="noopener noreferrer">
                                Czytaj na blogu
                            </a>

                        </Box>
                    </Box>

                </Box>

                <Box className={clsx(css.footer)}>
                    {categories && categories.length > 0 && (
                        <Box className={clsx(css.categories)}>
                            <Box className={clsx(css.title)}>
                                Więcej:
                            </Box>
                            <Box className={clsx(css.list)}>
                                {categories.map((category, index) => (

                                    <Box className={clsx(css.category)} key={index}>
                                        <a href={category.link} target="_blank" rel="noopener noreferrer">
                                            {category.name}
                                        </a>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}

                </Box>
            </Box>

        )

    );
}